"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const req_1 = require("../../../app/dist/req");
exports.toolDef = {
    name: 'loom_create_req',
    description: "Create a thread's req (requirements) doc — the authoritative include/exclude/constraints spec, one flat `req.md` per thread. **Pass `content` to write the three ID'd lists in this same call** (the safe, faithful extraction of what the user explicitly stated in chat) so the doc is born at version 1 with real content. Body shape: `### ✅ Included` / `### ❌ Excluded` / `### ⛓ Constraints`, each bullet prefixed with an inline-code stable id (`IN1`, `EX1`, `C1`). The doc is created at status \"draft\" — lock it with loom_finalize_req. Use this tool to create a req doc — do not edit weave files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            weaveId: { type: 'string', description: 'Target weave id' },
            threadId: { type: 'string', description: 'Thread id inside the weave' },
            title: { type: 'string', description: 'Optional title override (defaults to "{idea title} — Requirements")' },
            content: { type: 'string', description: "Markdown body (no frontmatter): the three ID'd lists. Provide on creation so the doc is born at v1 with real content." },
        },
        required: ['weaveId', 'threadId'],
    },
};
async function handle(root, args) {
    const result = await (0, req_1.createReq)({
        weaveId: args['weaveId'],
        threadId: args['threadId'],
        title: args['title'],
        content: args['content'],
    }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), saveDoc: dist_1.saveDoc, loadDoc: dist_1.loadDoc, fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
